import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics } from 'firebase/analytics'


const firebaseConfig = {
    // Prod DB
    apiKey: "AIzaSyBYle8oEsMlQ6C014YLyyOu9E3Ztnqj1QA",
    authDomain: "tribeca-landingpage.firebaseapp.com",
    projectId: "tribeca-landingpage",
    storageBucket: "tribeca-landingpage.firebasestorage.app",
    messagingSenderId: "439596980679",
    appId: "1:439596980679:web:c46afe7324c62b680f61e2",
    measurementId: "G-GL001309QY"
};


// 🔥 Initialize app FIRST
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// 🔥 Then initialize Firestore
const db = getFirestore(app);

// ✅ Export AFTER initialization
export { db, auth };
export const analytics = getAnalytics(app)  // ✅ add this

